import { render, staticRenderFns } from "./ProductInfoMarquee.vue?vue&type=template&id=e7efdf28&scoped=true"
import script from "./ProductInfoMarquee.vue?vue&type=script&lang=js"
export * from "./ProductInfoMarquee.vue?vue&type=script&lang=js"
import style0 from "./ProductInfoMarquee.vue?vue&type=style&index=0&id=e7efdf28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7efdf28",
  null
  
)

export default component.exports